import React from 'react';

import { withCarMapState } from '../../../shared/containers/containerCarMapState'

import ButtonIconDefault from '../../../shared/items/contols/buttonIconDefault'
import Icon from '../../../shared/items/static/icon'
import TooltipWrapper from './../../../shared/items/contols/tooltipWrapper'
import { mapState } from '../cars/static.carMapState'

import styles from './intelligenceMapWrapper.module.scss'

const IntelligenceMapControls = props => {
  const { onChangeCarMapState, carMapState } = props

  switch (carMapState.mapSize) {
    case mapState.fullSize.name:
      return <React.Fragment>
        {/* <TooltipWrapper title="Информация" position="top">
          <div className={styles.container_controlItem}>
            <ButtonIconDefault>
              <Icon name="Union" />
            </ButtonIconDefault>
          </div>
        </TooltipWrapper> */}
        <TooltipWrapper title="Уменьшить карту" position="top">
          <div className={styles.container_controlItem}>
            <ButtonIconDefault handleClick={onChangeCarMapState.bind(this, 'mapSize', mapState.baseSize.name)}>
              <Icon name="icon-2" />
            </ButtonIconDefault>
          </div>
        </TooltipWrapper>
      </React.Fragment>
    default:
      return <React.Fragment>
        <TooltipWrapper title="На весь экран" position="top">
          <div className={styles.container_controlItem}>
            <ButtonIconDefault handleClick={onChangeCarMapState.bind(this, 'mapSize', mapState.fullSize.name)}>
              <Icon name="icon-1" />
            </ButtonIconDefault>
          </div>
        </TooltipWrapper>
      </React.Fragment>
  }
}

export default withCarMapState(React.memo(IntelligenceMapControls))
